/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Rating_StarsInputs */

const en_rating_stars = /** @type {(inputs: Rating_StarsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} stars`)
};

const de_rating_stars = /** @type {(inputs: Rating_StarsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Sterne`)
};

/**
* | output |
* | --- |
* | "{count} stars" |
*
* @param {Rating_StarsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rating_stars = /** @type {((inputs: Rating_StarsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rating_StarsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_rating_stars(inputs)
	return en_rating_stars(inputs)
});